export default __webpack_public_path__ + "static/media/cert-general-staff-cpttm-sc.f21a7fd0.jpg";